import {
  UserStatus,
  type UserStatus as UserStatusType,
} from "@vega-api/generated/types/userStatus";
import { TagVariants } from "@vega-core/components/Tag/Tag";

export const getUserStatusVariant = (status: UserStatusType): TagVariants => {
  switch (status) {
    case UserStatus.ACTIVE:
      return TagVariants.Positive;
    case UserStatus.INACTIVE:
      return TagVariants.Negative;
    case UserStatus.INVITED:
      return TagVariants.Data2;
    default:
      return TagVariants.Data1;
  }
};
